/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CheckRun } from './CheckRun';
import {
    CheckRunFromJSON,
    CheckRunFromJSONTyped,
    CheckRunToJSON,
} from './CheckRun';

/**
 * Derived screener decision for a lead. Combines pre-screen audit rows and `screener_suggestion` (LeadAnalyzer output, surfaced as a synthetic `analyzer` check). Populated by lead-read endpoints that load the underlying inputs (`leadsFindOne`, `leadsFindAll`); other lead-read paths may omit this field.
 * @export
 * @interface EffectiveDecision
 */
export interface EffectiveDecision {
    /**
     * 
     * @type {string}
     * @memberof EffectiveDecision
     */
    decision: EffectiveDecisionDecisionEnum;
    /**
     * 
     * @type {Array<CheckRun>}
     * @memberof EffectiveDecision
     */
    checks: Array<CheckRun>;
}


/**
 * @export
 */
export const EffectiveDecisionDecisionEnum = {
    Accept: 'Accept',
    Reject: 'Reject',
    Maybe: 'Maybe',
    Pending: 'Pending',
    Cancelled: 'Cancelled',
    NA: 'N/A'
} as const;
export type EffectiveDecisionDecisionEnum = typeof EffectiveDecisionDecisionEnum[keyof typeof EffectiveDecisionDecisionEnum];


/**
 * Check if a given object implements the EffectiveDecision interface.
 */
export function instanceOfEffectiveDecision(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "decision" in value;
    isInstance = isInstance && "checks" in value;

    return isInstance;
}

export function EffectiveDecisionFromJSON(json: any): EffectiveDecision {
    return EffectiveDecisionFromJSONTyped(json, false);
}

export function EffectiveDecisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): EffectiveDecision {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'decision': json['decision'],
        'checks': ((json['checks'] as Array<any>).map(CheckRunFromJSON)),
    };
}

export function EffectiveDecisionToJSON(value?: EffectiveDecision | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'decision': value.decision,
        'checks': ((value.checks as Array<any>).map(CheckRunToJSON)),
    };
}

